import { transformToHtml } from '../../utils/CommonUtils';

export default function ErrorFlightDistanceDT() {
  const errorMessage = `<div id="fullpage-error" class="fullpage-error-wrapper">
    <div class="fullpage-error-container">
        <span class="fullpage-error-icon" style="background-image: url(https://jsak.mmtcdn.com/seo/assets/img/ic_nocompatible_full.png);"></span>
        <p class="error-title"> Sorry No flights found</p>
        <div class="error-cta-wrapper">
            </div>
    </div>
</div>`;
  return (
    transformToHtml(errorMessage)
  );
}
